import React, { forwardRef } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import './pulsating-purple-dot-keyframes.css';
import { clsx } from '@mentimeter/ragnar-tailwind-config';

interface PulsatingPurpleDotProps {
  size: number;
}

export const PulsatingPurpleDot = forwardRef(
  ({ size = 36 }: PulsatingPurpleDotProps, ref) => {
    return (
      <Box position="relative" width={size} height={size} ref={ref}>
        <Box
          width="100%"
          height="100%"
          position="absolute"
          borderRadius="50%"
          bg="info"
          zIndex={1}
          className={clsx('pulsating-purple-dot-animation')}
        />
        <Box
          width="100%"
          height="100%"
          position="absolute"
          borderRadius="50%"
          bg="infoWeak"
          className={clsx('pulsating-translucent-dot-animation')}
        />
      </Box>
    );
  },
);
